module.exports = __webpack_public_path__ + "img/facebook-white.595d2883.svg";